/**
 * UYGULAMA İÇİ ONAY PENCERESİ (2026-08-20) — tarayıcının çirkin window.confirm'i
 * ("localhost:5173 web sitesinin mesajı") yerine uygulamanın kendi görünümünde onay.
 * Kullanım:
 *   const { onayIste, OnayPenceresi } = useOnay();
 *   ... await onayIste({ baslik, aciklama, onayYazisi?, tehlikeli? }) → boolean
 *   JSX'in sonuna: {OnayPenceresi}
 */
import { useCallback, useState, type ReactNode } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface OnayAyar {
  baslik: string;
  aciklama: string;
  onayYazisi?: string;   // varsayılan "Devam Et"
  vazgecYazisi?: string; // varsayılan "Vazgeç"
  tehlikeli?: boolean;   // kırmızı onay düğmesi (geri alma/koparma gibi)
}

export function useOnay(): { onayIste: (a: OnayAyar) => Promise<boolean>; OnayPenceresi: ReactNode } {
  const [ayar, setAyar] = useState<(OnayAyar & { resolve: (v: boolean) => void }) | null>(null);

  const onayIste = useCallback((a: OnayAyar) => new Promise<boolean>((resolve) => setAyar({ ...a, resolve })), []);
  const kapat = (sonuc: boolean) => { ayar?.resolve(sonuc); setAyar(null); };

  const OnayPenceresi = ayar ? (
    <AlertDialog open onOpenChange={(acik) => { if (!acik) kapat(false); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{ayar.baslik}</AlertDialogTitle>
          <AlertDialogDescription className="whitespace-pre-line">{ayar.aciklama}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => kapat(false)}>{ayar.vazgecYazisi ?? "Vazgeç"}</AlertDialogCancel>
          <AlertDialogAction
            className={ayar.tehlikeli ? "bg-red-600 hover:bg-red-700 text-white" : "bg-brand-500 hover:bg-brand-600 text-white"}
            onClick={() => kapat(true)}>
            {ayar.onayYazisi ?? "Devam Et"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  ) : null;

  return { onayIste, OnayPenceresi };
}
